import { Controller } from "@hotwired/stimulus";
import { useDebounce } from "stimulus-use";

// Connects to data-controller="form"
export default class extends Controller {
  static debounces = ["submit"];
  static targets = ["submitter"];

  connect() {
    useDebounce(this);
  }

  submit(event) {
    const threshold = event.params.threshold;
    const value = event.target.value;

    // Do not submit if value length is less than threshold
    if (threshold && value && value.length < threshold) {
      return;
    }

    this.element.requestSubmit();
  }

  /**
   * Method for re-executing rails-conditions in view
   * Usage:
   *   1. Wrap "<form>" in "turbo_frame_tag :form";
   *   2. Define "data: { action: "form#renderSubmit" }" for inputs, which will send request;
   *   3. Define "<%= f.submit name: "render", data: { form_target: "submitter" } %>";
   *   4. In Rails-controller in method write "return render `your action` if params[:render].present?".
   */
  renderSubmit() {
    this.element.setAttribute("data-turbo-frame", "form");
    this.element.setAttribute("novalidate", "true");
    this.element.requestSubmit(this.submitterTarget);
  }
}
